import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchCustomersInBranchPerHourReport from "../../../components/branches/reports/daily/BranchNumberOfCustomersInHour";
import {
  CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const BranchCustomersInBranchPerHour = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS}
    descriptionKey="BranchesCustomersInBranchPerHour"
    normalizeData={asArray}
    title={`${reportIndex}. Customers In Branch Per Hour`}
  >
    {({ data, renderConfig }) => (
      <BranchCustomersInBranchPerHourReport data={data} reportIndex={reportIndex} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default BranchCustomersInBranchPerHour;
